<template>
  <svg class="i">
    <use :xlink:href="url" />
  </svg>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
      type: String,
    },
  },
  computed: {
    url () {
      return `#${this.icon}`
    },
  },
}
</script>

<style lang="scss">
  $icon-size-base: 1rem;

  .i {
    fill: currentColor;
    width: $icon-size-base;
    height: $icon-size-base;
    top: -1px;
    position: relative;
    margin: auto;
    display: inline-block;
    &-2x {
      width: $icon-size-base * 1.5;
      height: $icon-size-base * 1.5;
      top: -2px;
    }
  }
</style>
